/** @file Typography tokens for Playfair Display headings and Outfit body text. */

export const typography = {
  fontFamily: '"Outfit", sans-serif',
  headings: {
    fontFamily: '"Playfair Display", serif',
    sizes: {
      h1: { fontSize: 'clamp(2.5rem, 6vw, 4rem)', lineHeight: '1.1', fontWeight: '700' },
      h2: { fontSize: 'clamp(2rem, 4vw, 3rem)', lineHeight: '1.2', fontWeight: '700' },
      h3: { fontSize: 'clamp(1.5rem, 3vw, 2.25rem)', lineHeight: '1.3', fontWeight: '600' },
      // clamp() max equals the previous fixed size, so desktop is unchanged.
      h4: { fontSize: 'clamp(1.25rem, 2.2vw, 1.5rem)', lineHeight: '1.4', fontWeight: '600' },
      h5: { fontSize: 'clamp(1.125rem, 1.8vw, 1.25rem)', lineHeight: '1.5', fontWeight: '500' },
      h6: { fontSize: 'clamp(1rem, 1.5vw, 1.125rem)', lineHeight: '1.5', fontWeight: '500' }
    }
  }
};
